const messages = {
    ast: {
        'Vocables': 'Vocablos',
        'Practice': 'Práutica',
        'Settings': 'Configuración',
        'Add Vocable': 'Amiestu d\'un vocablu',
        'Edit Vocable': 'Edición del vocablu',
        'Save': 'Guardar',
        'Word': 'Pallabra',
        'Translation': 'Traducción',
        'Vocable has been added': 'Amestóse un vocablu',
        'Vocable has been updated': 'Anovóse\'l vocablu',
        'Vocable has been deleted': 'Desanicióse\'l vocablu',
        'Add Box': 'Amiestu d\'una caxa',
        'Edit Box': 'Edición de la caxa',
        'Name': 'Nome',
        'Box has been added': 'Amestóse una caxa',
        'Box has been updated': 'Anovóse la caxa',
        'Box has been deleted': 'Desanicióse la caxa',
        'Do you really want to delete this box?': '¿De xuru que quies desaniciar esta caxa?',
        'Do you really want to delete this vocable?': '¿De xuru que quies desaniciar esti vocablu?',
        'DELETE': 'DESANICIAR',
        'Cancle': 'ENCABOXAR',
        'Wrong': 'Mal',
        'The correct answer is <b>x</b>': 'La rempuesta correuta ye <b>{x}</b>',
        'Okay': 'D\'acuerdu',
        'x vocables': '{x} vocablos',
        'Made it!': '¡Consiguiéstilo!',
        'You have practiced all vocables in this box.': 'Prautiquesti tolos vocablos d\'esta caxa.',
        'Correct': 'Bien',
        'You have practiced all your vocables. Come back later to practice again.': 'Prautiquesti tolos vocablos, volvi dempués pa volver prauticalos.',
        '{x} vocables have been imported': 'Importáronse {x} vocablos',
        'Restart': 'Reaniciar',
        'Warning': 'Alvertencia',
        'Name can not be empty.': 'El campu del nome nun pue tar baleru.',
        'Word can not be empty.': 'El campu de la pallabra nun pue tar baleru.',
        'Translation can not be empty.': 'El campu de la traducción nun pue tar baleru.',
        'Check answer': 'Comprobar la rempuesta',
    },
    en: {
        'Vocables': 'Vocables',
        'Practice': 'Practice',
        'Settings': 'Settings',
        'Add Vocable': 'Add Vocable',
        'Edit Vocable': 'Edit Vocable',
        'Save': 'Save',
        'Word': 'Word',
        'Translation': 'Translation',
        'Vocable has been added': 'Vocable has been added',
        'Vocable has been updated': 'Vocable has been updated',
        'Vocable has been deleted': 'Vocable has been deleted',
        'Add Box': 'Add Box',
        'Edit Box': 'Edit Box',
        'Name': 'Name',
        'Box has been added': 'Box has been added',
        'Box has been updated': 'Box has been updated',
        'Box has been deleted': 'Box has been deleted',
        'Do you really want to delete this box?': 'Do you really want to delete this box?',
        'Do you really want to delete this vocable?': 'Do you really want to delete this vocable?',
        'DELETE': 'DELETE',
        'Cancle': 'Cancel',
        'Wrong': 'Wrong',
        'The correct answer is <b>x</b>': 'The correct answer is <b>{x}</b>',
        'Okay': 'Okay',
        'x vocables': '{x} vocables',
        'Made it!': 'Made it!',
        'You have practiced all vocables in this box.': 'You have practiced all vocables in this box.',
        'Correct': 'Correct',
        'You have practiced all your vocables. Come back later to practice again.': 'You have practiced all your vocables. Come back later to practice again.',
        '{x} vocables have been imported': '{x} vocables have been imported',
        'Restart': 'Restart',
        'Warning': 'Warning',
        'Name can not be empty.': 'Name can not be empty.',
        'Word can not be empty.': 'Word can not be empty.',
        'Translation can not be empty.': 'Translation can not be empty.',
        'Check answer': 'Check answer',
    },
    de: {
        'Vocables': 'Vokabeln',
        'Practice': 'Üben',
        'Settings': 'Einstellungen',
        'Add Vocable': 'Vokabel hinzufügen',
        'Edit Vocable': 'Vokabel bearbeiten',
        'Save': 'Speichern',
        'Word': 'Wort',
        'Translation': 'Übersetzung',
        'Vocable has been added': 'Vokabel wurde hinzugefügt',
        'Vocable has been updated': 'Vokabel wurde aktualisiert',
        'Vocable has been deleted': 'Vokabel wurde gelöscht',
        'Add Box': 'Box hinzufügen',
        'Edit Box': 'Box bearbeiten',
        'Name': 'Name',
        'Box has been added': 'Box wurde hinzugefügt',
        'Box has been updated': 'Box wurde aktualisiert',
        'Box has been deleted': 'Box wurde gelöscht',
        'Do you really want to delete this box?': 'Möchten Sie diese Box wirklich löschen?',
        'Do you really want to delete this vocable?': 'Möchten Sie diese Vokabel wirklich löschen?',
        'DELETE': 'LÖSCHEN',
        'Cancle': 'Abbrechen',
        'Wrong': 'Falsch',
        'The correct answer is <b>x</b>': 'Die richtige Antwort ist <b>{x}</b>',
        'Okay': 'Okay',
        'x vocables': '{x} Vokabeln',
        'Made it!': 'Geschafft!',
        'You have practiced all vocables in this box.': 'Sie haben alle Vokabeln in dieser Box geübt.',
        'Correct': 'Richtig',
        'You have practiced all your vocables. Come back later to practice again.': 'Sie haben alle Ihre Vokabeln geübt. Kommen Sie später wieder, um erneut zu üben.',
        '{x} vocables have been imported': '{x} Vokabeln wurden importiert',
        'Restart': 'Neustart',
        'Warning': 'Warnung',
        'Name can not be empty.': 'Name darf nicht leer sein.',
        'Word can not be empty.': 'Wort darf nicht leer sein.',
        'Translation can not be empty.': 'Übersetzung darf nicht leer sein.',
        'Check answer': 'Antwort überprüfen',
    }
};

export default messages
